import { DecisionsSectionStyles } from './decisions.style';
import {
  ContentBlock,
  ContentBlockProps,
} from '@exploration/shared-components';
import { MDSInlineLink } from '@midwest/web/inline-link';

// --------------------------------------------------------------------------

const {
  Section,
  SectionContainer,
  Headline,
  SubHeadline,
  ContentBox,
  ImageContent,
  StyledImage,
  ImageBanner,
  ImagePercentage,
  ImageSubHeadline,
  ImageSpan,
  ImageBannerRight,
  ImageBannerClickable,
  CTAContainer,
} = DecisionsSectionStyles;

// --------------------------------------------------------------------------

export interface DecisionsSectionProps {
  headline: string;
  subHeadline: string;
  subHeadlineLink: {
    text: string;
    url: string;
  };
  images: {
    alt: string;
    src: string;
  }[];
  contentBlocks: ContentBlockProps[];
  id?: string;
}

// --------------------------------------------------------------------------

const DecisionsSection = ({
  headline,
  subHeadline,
  subHeadlineLink,
  images,
  contentBlocks,
  id,
}: DecisionsSectionProps) => {
  return (
    <Section id={id}>
      <SectionContainer>
        <Headline as="h2">{headline}</Headline>
        <SubHeadline>
          {subHeadline}{' '}
          <MDSInlineLink href={subHeadlineLink.url}>
            {subHeadlineLink.text}
          </MDSInlineLink>
          .
        </SubHeadline>
      </SectionContainer>
      <CTAContainer
        textComponent={
          <ContentBox>
            <ContentBlock
              headline={contentBlocks[0].headline}
              subHeadline={contentBlocks[0].subHeadline}
              checkMarkItems={contentBlocks[0].checkMarkItems}
            />
          </ContentBox>
        }
        imageComponent={
          <ImageContent>
            <StyledImage
              src={images[0].src}
              alt={images[0].alt}
              width={720}
              height={409}
            />
            <ImageBanner>
              <ImageBannerClickable href={subHeadlineLink.url}>
                <ImagePercentage>75%</ImagePercentage>
                <ImageSubHeadline>
                  place <ImageSpan>family</ImageSpan> at the heart of their
                  values
                </ImageSubHeadline>
              </ImageBannerClickable>
            </ImageBanner>
          </ImageContent>
        }
        reverseMobile
        imageBreakout
      />
      <CTAContainer
        imageComponent={
          <ImageContent>
            <StyledImage
              src={images[1].src}
              alt={images[1].alt}
              width={720}
              height={409}
            />
            <ImageBannerRight>
              <ImageBannerClickable href={subHeadlineLink.url}>
                <ImagePercentage>40%</ImagePercentage>
                <ImageSubHeadline>
                  rate <ImageSpan>financial stability</ImageSpan> as a top value
                </ImageSubHeadline>
              </ImageBannerClickable>
            </ImageBannerRight>
          </ImageContent>
        }
        textComponent={
          <ContentBox>
            <ContentBlock
              headline={contentBlocks[1].headline}
              subHeadline={contentBlocks[1].subHeadline}
              checkMarkItems={contentBlocks[1].checkMarkItems}
            />
          </ContentBox>
        }
        reverseMobile
        imageBreakout
        reverseDesktop
      />
    </Section>
  );
};

// --------------------------------------------------------------------------

export default DecisionsSection;
